import { createStore } from 'vuex';
import api from '@/helpers/api';
import router from '@/router';

import { 
  getFromStorage as getFromLocalStorage,
  setToStorage as setToLocalStorage,
  deleteFromStorage as deleteFromLocalStorage,
} from '@/helpers/localStorage';

import { redirectTo } from '@/utils/common';

export interface State {
  isLoggedIn: boolean,
  searchData: any;
  isLoadingInProgress: boolean;
}

export default createStore<State>({
  state: {
    isLoggedIn: !!getFromLocalStorage('token'),
    searchData: null,
    isLoadingInProgress: false
  },
  getters: {
    getSearchData: (state) => state.searchData,
    getIsLoadingInProgress: (state) => state.isLoadingInProgress,
    getIsLoggedIn: (state) => state.isLoggedIn,
  },
  mutations: {
    SET_IS_LOGGED_IN(state, isLoggedIn: boolean) {
      console.log('SET_IS_LOGGED_IN', isLoggedIn);
      state.isLoggedIn = isLoggedIn;
    },
    SET_CURRENT_USER(state, user) {
      console.log('SET_CURRENT_USER', user);
      state.isLoggedIn = true;
      setToLocalStorage('user', user);
    },
    setIsLoadingInProgress(state, isLoading) {
      state.isLoadingInProgress = isLoading
    },
    setSearchData(state, data) {
      state.searchData = data;
    },
    resetSearchData(state) {
      state.searchData = {};
    }
  },
  actions: {
     async LOGIN({ commit, dispatch, state }) {
      console.log('LOGIN');
      commit('SET_IS_LOGGED_IN', true);
      // if (state.isLoggedIn) {
      //   dispatch('getAuthUser');
      // }
    },
    async LOGOUT({ commit, dispatch, state }) {
      console.log('LOGOUT');
      deleteFromLocalStorage('token');
      deleteFromLocalStorage('refreshToken');
      commit('SET_IS_LOGGED_IN', false);
    },
    // getAuthUser({ commit, state, dispatch }) {
    //   api.getAuthUser()
    //   .then((res: any) => {
    //     const user = res.data && res.data.result;
    //     if (user) {
    //       commit('SET_CURRENT_USER', user);
          
    //       return;
    //     }
    //     dispatch('LOGOUT');
    //   })
    //   .catch((err: any) => {
    //     const status = err?.response?.status;

    //     if (status === 401 || status === 403) {
    //       commit('SET_IS_LOGGED_IN', false);
    //       commit('SET_CURRENT_USER', {});
    //       deleteFromLocalStorage('token');
    //       deleteFromLocalStorage('refreshToken');
    //       deleteFromLocalStorage('user');
    //     }
    //   });
    // },
    searchBlockchain({ state }, searchStr) {
      this.commit('setIsLoadingInProgress', true);

       return api.searchBlockchainBySearchStr(searchStr)
        .then((res) => {
          const data = (res as { data: any }).data;
          console.log('searchBlockchain', data);


          this.commit('setSearchData', data.result);
          this.commit('setIsLoadingInProgress', false);

          router.push({
          name: 'results',
          query: { value: searchStr }
      });
        })
        .catch((err) => {
          this.commit('setIsLoadingInProgress', false);
          this.commit('setSearchData', {});
        })
    },
  }
});
